import axios from "axios";
import { requestHeader } from "./global_functions";
import { AGENT_LOGIN_API } from "./config";

function AgentLogin(credential, csrfToken) {
  return axios.post(`${AGENT_LOGIN_API}`, credential, {
    headers: {
      Accept: "application/json",
      "Access-Control-Allow-Credentials": true,
      "x-xsrf-token": csrfToken,
    },
    withCredentials: true,
  });
}

function GetDataListFromServer(prefix, query, access_token, csrf_token) {
  return axios.get(
    `${prefix}?${query}`,
    requestHeader(access_token, csrf_token)
  );
}

function GetDataListByIdFromServer(prefix, id, query, access_token, csrf_token) {
  return axios.get(`${prefix}/${id}?${query}`, requestHeader(access_token, csrf_token))
}

function GetDataListById(prefix, id, access_token, csrf_token) {
  return axios.get(`${prefix}/${id}`, requestHeader(access_token, csrf_token));
}

function GetDataFromServer(prefix, access_token) {
  return axios.get(`${prefix}`, requestHeader(access_token));
}

function CreateDataOnServer(prefix, data, access_token, csrf_token) {
  return axios.post(`${prefix}`, data, requestHeader(access_token, csrf_token));
}

function CreateDataById(prefix, id, data, access_token, csrf_token) {
  return axios.post(
    `${prefix}/${id}`,
    data,
    requestHeader(access_token, csrf_token)
  );
}

function UpdateDateOnServer(prefix, id, data, access_token, csrf_token) {
  return axios.patch(
    `${prefix}/${id}`,
    data,
    requestHeader(access_token, csrf_token)
  );
}

function UpdateDataWithUserIdOnServer(
  prefix,
  name,
  user_id,
  access_token,
  csrf_token
) {
  return axios.patch(
    `${prefix}/${name}/${user_id}`,
    {},
    requestHeader(access_token, csrf_token)
  );
}

function DeleteDataOnServer(prefix, id, access_token, csrf_token) {
  return axios.delete(
    `${prefix}/${id}`,
    requestHeader(access_token, csrf_token)
  );
}

function LoginEmailCheck(prefix, email, access_token) {
  return axios.get(`${prefix}/${email}`, requestHeader(access_token));
}

function CodeCheck(prefix, code, access_token) {
  return axios.get(`${prefix}/${code}`, requestHeader(access_token));
}

function UpdateSingleDataOnServer(prefix, id, access_token, csrf_token) {
  return axios.patch(
    `${prefix}/${id}`,
    {},
    requestHeader(access_token, csrf_token)
  );
}

function UpdateUnlockDataOnServer(prefix, id, access_token, csrf_token) {
  return axios.patch(
    `${prefix}/${id}`,
    {},
    requestHeader(access_token, csrf_token)
  );
}

function UpdatebankDataOnServer(prefix, id ,access_token, csrf_token) {
  return axios.patch(
    `${prefix}/${id}`,
    {},
    requestHeader(access_token, csrf_token)
  );
}


function UpdateUserDefaultBank(
  prefix,
  user_id,
  account_id,
  access_token,
  csrf_token
) {
  return axios.patch(
    `${prefix}/${user_id}/${account_id}`,
    {},
    requestHeader(access_token, csrf_token)
  );
}

function UpdateSingleDataWithBody(prefix, id, data, access_token, csrf_token) {
  return axios.patch(
    `${prefix}/${id}`,
    data,
    requestHeader(access_token, csrf_token)
  );
}

function UpdateTransactionDataOnServer(
  prefix,
  user_id,
  transaction_id,
  data,
  access_token,
  csrf_token
) {
  return axios.patch(
    `${prefix}/${user_id}/${transaction_id}`,
    data,
    requestHeader(access_token, csrf_token)
  );
}

function passwordReset(prefix, id, data, access_token, csrf_token) {
  return axios.patch(`${prefix}/${id}`, data, requestHeader(access_token, csrf_token))
}

function passwordOwnReset(prefix, data, access_token, csrf_token) {
  return axios.patch(`${prefix}`, data, requestHeader(access_token, csrf_token))
}



function getListFromServer(prefix, access_token) {
  return axios.get(`${prefix}`, requestHeader(access_token));
}

function updateUserDataOnServer(prefix, data, access_token, csrf_token) {
  return axios.patch(
    `${prefix}`,
    data,
    requestHeader(access_token, csrf_token)
  );
}

export {
  AgentLogin,
  CodeCheck,
  GetDataListFromServer,
  GetDataListByIdFromServer,
  GetDataListById,
  CreateDataOnServer,
  CreateDataById,
  UpdateDateOnServer,
  DeleteDataOnServer,
  UpdateSingleDataOnServer,
  UpdatebankDataOnServer,
  UpdateUnlockDataOnServer,
  UpdateDataWithUserIdOnServer,
  LoginEmailCheck,
  GetDataFromServer,
  getListFromServer,
  updateUserDataOnServer,
  UpdateSingleDataWithBody,
  UpdateTransactionDataOnServer,
  UpdateUserDefaultBank,
  passwordReset,
  passwordOwnReset
};
